import _Promise from "@babel/runtime-corejs2/core-js/promise";
/* eslint no-param-reassign: 0 */
import * as React from 'react';
import { getDataDependency, getDisplayName } from 'gandi.react-helpers';
import hoistNonReactStatic from 'hoist-non-react-statics';
import TranslatorPropsContext from './TranslatorPropsContext';
import createTranslatorProps from './createTranslatorProps';
/**
 * Provide the translator for the whole application.
 * @param Object translator           Translator object
 * @param String defaultScope         default translation scopes
 * @param Component WrappedComponent  A wrapper component
 * @return Component
 */

var provideTranslate = function provideTranslate(translator, namespace) {
  return function (WrappedComponent) {
    if (namespace && global.__DEV__) {
      // eslint-disable-next-line no-console
      console.warn('DEPRECATION WARNING:\n' + 'provideTranslator(translator, namespace) is deprecated.\n' + 'Use provideTranslator(translator) instead.\n' + 'The translation namespace is now defined in your application configuration.');
    }
    var translatorProps = createTranslatorProps(translator);
    function ProviderTranslate(props) {
      return /*#__PURE__*/React.createElement(TranslatorPropsContext.Provider, {
        value: translatorProps
      }, /*#__PURE__*/React.createElement(WrappedComponent, props));
    }
    ProviderTranslate.WrappedComponent = WrappedComponent;
    ProviderTranslate.displayName = "ProviderTranslate(".concat(getDisplayName(WrappedComponent), ")");
    var HoistedComponent = hoistNonReactStatic(ProviderTranslate, WrappedComponent);
    var wrapHandler = function wrapHandler(handlerName) {
      var wrappedHandler = getDataDependency(WrappedComponent, handlerName);
      HoistedComponent[handlerName] = function (props) {
        // Always inject `translator` here: it is relied-on by `withTranslator`...
        props.res.locals.translator = translator;

        // Call child preFetch if any
        if (!wrappedHandler) {
          return _Promise.resolve();
        }
        for (var _len = arguments.length, extra = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          extra[_key - 1] = arguments[_key];
        }
        return wrappedHandler.apply(void 0, [props].concat(extra));
      };
      return HoistedComponent;
    };
    wrapHandler('preFetch');
    wrapHandler('handleRedirect');
    wrapHandler('handleForm');
    return ProviderTranslate;
  };
};
export default provideTranslate;